import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { withStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import CircularProgress from '@material-ui/core/CircularProgress';

import api from '../../lib/api';
import {
  confirmEmailErrorDetail,
  isConfirmEmailSuccess,
} from '../../lib/confirmEmail';

export class ConfirmEmail extends Component {
  constructor(props) {
    super(props);

    this.state = {
      loading: true,
      error: null,
      success: false,
    };
  }

  goToLogin = (confirmed) => {
    const path = confirmed ? '/login?emailConfirmed=true' : '/login';
    if (this.props.history && this.props.history.push) {
      this.props.history.push(path);
      return;
    }
    window.location.href = path;
  };

  async componentDidMount() {
    const params = new URLSearchParams(this.props.location.search);
    const token = params.get('token');
    const email = params.get('email');

    if (!token || !email) {
      this.setState({
        loading: false,
        error: 'Неверная ссылка подтверждения',
      });
      return;
    }

    try {
      const result = await api.confirmModeratorEmail(token, email);
      const status = result && result.status;
      const body = result && result.body;
      const type = result && result.type;
      const legacyRedirect = type === 'opaqueredirect' || status === 0;

      if (legacyRedirect || isConfirmEmailSuccess(status, body)) {
        this.setState({
          loading: false,
          success: true,
        });
        return;
      }

      this.setState({
        loading: false,
        error: confirmEmailErrorDetail(body) || 'Ошибка при подтверждении email',
      });
    } catch (err) {
      this.setState({
        loading: false,
        error: (err && err.message) || 'Ошибка при подтверждении email. Попробуйте позже.',
      });
    }
  }

  render() {
    const { classes } = this.props;

    return (
      <div className={classes.container}>
        <Paper className={classes.loginPaper} elevation={2}>
          {this.state.loading && (
            <>
              <CircularProgress />
              <Typography variant="body1" className={classes.statusText}>
                Подтверждение email...
              </Typography>
            </>
          )}
          {this.state.success && (
            <>
              <Typography variant="h5" color="primary" gutterBottom>
                Email успешно подтвержден!
              </Typography>
              <Typography variant="body1" className={classes.statusText}>
                Войдите в систему.
              </Typography>
              <Button
                variant="contained"
                color="primary"
                onClick={() => this.goToLogin(true)}
              >
                Вход
              </Button>
            </>
          )}
          {this.state.error && (
            <>
              <Typography variant="h5" color="error" gutterBottom>
                Ошибка
              </Typography>
              <Typography variant="body1" className={classes.statusText}>
                {this.state.error}
              </Typography>
              <Button
                variant="contained"
                color="primary"
                onClick={() => this.goToLogin(false)}
              >
                Вход
              </Button>
            </>
          )}
        </Paper>
      </div>
    );
  }
}

const styles = () => ({
  container: {
    display: 'flex',
    flex: 1,
    alignItems: 'center',
    justifyContent: 'center',
  },
  loginPaper: {
    width: 400,
    padding: 25,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    minHeight: 200,
  },
  statusText: {
    marginTop: 20,
    marginBottom: 16,
    textAlign: 'center',
  },
});

export default withRouter(withStyles(styles)(ConfirmEmail));
